import { parseMealTransferCommand, type MealTransferCommand } from "../../backend/src/rules/meal-transfer.js";
import type { ISODate, MealType } from "../domain/model";
import { localISODate } from "./water-repository";

export class MealTransferError extends Error {}

export function mealTransferRoute(command: MealTransferCommand, sourceDate: ISODate, sourceType: MealType, today = localISODate()) {
  const relativeToSelected = ["previous", "next", "selected"].includes(command.day);
  const date = new Date(`${relativeToSelected ? sourceDate : today}T12:00:00`);
  const offset = { yesterday: -1, today: 0, tomorrow: 1, previous: -1, next: 1, selected: 0 }[command.day];
  date.setDate(date.getDate() + offset);
  const named = { date: localISODate(date), mealType: command.mealType ?? sourceType };
  const opened = { date: sourceDate, mealType: sourceType };
  const route = command.direction === "from" ? { source: named, target: opened } : { source: opened, target: named };
  if (route.source.date > today || route.target.date > today) throw new MealTransferError("Будущие дни не поддерживаются. Выберите сегодняшний или прошедший день.");
  return route;
}

export function readMealTransfer(text: string) {
  const command = parseMealTransferCommand(text);
  if (command && "error" in command) throw new MealTransferError(command.error);
  return command;
}
